import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCustomTheme } from "../../../core/design-system/CustomThemeProvider.js";
import { radius, spacing } from "../../../core/design-system/index.js";
import { Text } from "../components/text.js";
import { Spacer } from "./Spacer.js";
import { Container } from "./basic.js";
import { Button } from "./buttons.js";
export default function Tabs({ selected, onSelect, options, children, }) {
    const theme = useCustomTheme();
    return (_jsxs("div", { children: [_jsx(Container, { flex: "row", center: "y", style: { width: "100%", borderRadius: radius.lg }, p: "xxs", bg: "secondaryButtonBg", children: options.map((option) => (_jsx(Button, { variant: "accent", type: "button", onClick: () => onSelect(option.value), style: {
                        flex: 1,
                        paddingBlock: spacing.sm,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        position: "relative",
                        borderRadius: radius.md,
                        backgroundColor: option.value === selected
                            ? theme.colors.modalBg
                            : "transparent",
                    }, children: _jsx(Text, { color: option.value === selected ? "primaryText" : "secondaryText", style: { textAlign: "center" }, size: "sm", children: option.label }) }, option.value))) }), _jsx(Spacer, { y: "sm" }), children] }));
}
//# sourceMappingURL=Tabs.js.map